export enum SearchInFieldName {
  Headline = 'headline',
  Byline = 'byline',
  StoryText = 'storyText',
}
